import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import AuthorisedContactForm from '../forms/AuthorisedContactForm'
import { ACTION_ADD, ACTION_MODIFY } from '../constants'
import globals from '../globals'

class AuthorisedContact extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            authorisedContact: {}
        }
    }

    componentDidMount () {
        DataSource.getData('/api/getProfile?type=additional-contact-data', result => {
            this.setState({
                authorisedContact: result.authorisedContact,
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    isModifyOrAdd () {
        if (Object.keys(this.state.authorisedContact).length > 0) {
            return ACTION_MODIFY
        }

        return ACTION_ADD
    }

    render () {
        return (
            <div className='invoices module'>
                <Heading title='Manage authorised contact' />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2 text-center'>
                            <p>You can add the details of any person over 18 years of age who you authorise to talk to Exetel and make decisions about your account on your behalf. We will use the information provided here to identify your authorised contact before we do anything on your account.</p>
                        </div>
                        <div className='col-12 col-md-8 offset-md-2' style={{ position: 'inherit' }}>
                            <AuthorisedContactForm
                                fields={this.state.authorisedContact}
                                isVerified={this.props.isVerified}
                                handleVerificationSuccess={this.props.handleVerificationSuccess}
                                isModifyOrAdd={this.isModifyOrAdd.bind(this)}
                                handleSuccess={() => globals.pushEvent('ManageAuthorisedContactSubmit')}
                            />
                            <div className='my-3'>
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

export default AuthorisedContact



// WEBPACK FOOTER //
// ./resources/js/modules/AuthorisedContact.js